/*
*
* File JS componente Block Related Posts
*
*/

 
// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './index.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockRelatedPosts = () => {


};
var _default = blockRelatedPosts;

if (typeof window !== 'undefined' && typeof _default !== 'undefined') {
  window.__imComponents = window.__imComponents || {};
  window.__imComponents["block-related-posts"] = _default;
}

export default blockRelatedPosts;

//--------------------------------------------------------------------//